'use client'
import React, {Suspense} from "react";
import {ReactNode} from "react";
import {SettingsProvider} from "../../Layouts/SettingsContext";
import {DefaultSettings} from "@/Settings";
import {TooltipProvider} from "../../Tooltip";

const Loader = ({children}: { children: ReactNode }) => {
    return (
        <>
            <TooltipProvider>
                <SettingsProvider
                    defaults={DefaultSettings}
                >
                    {children}
                </SettingsProvider>
            </TooltipProvider>
        </>
    );
};

export default Loader;